import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import '../Customers/CustomersStyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSearch, faFileImport } from '@fortawesome/free-solid-svg-icons';
import AddCustomer from './AddCustomer';
import ImportCustomers from './ImportCustomers';
import EditIcon from '../../Images/ic_edit.svg';
import DeleteIcon from '../../Images/ic_delete.svg';
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import Regions from '../Common/Region';

const Customers = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    // eslint-disable-next-line
    const [companyInfo, setCompanyInfo] = useState([]);
    const [customerData, setcustomerData] = useState([]);
    const [customerEditData, setcustomerEditData] = useState([]);
    const [displayAddCustomer, setdisplayAddCustomer] = useState("none");
    const [displayImportCustomer, setdisplayImportCustomer] = useState("none");
    const [IsEdit, setIsEdit] = useState(0);
    const [FilterCustomer, setFilterCustomer] = useState([]);
    const [RegionSymbol, setRegionSymbol] = useState({});

    useEffect(() => {
        FetchCustomers();

        if (localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);
            var region = Regions.filter(r => r.Code === companyDetails.CountryCode);
            if (region.length > 0) {
                setRegionSymbol(region[0]);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const CustomerDataSuccess = (data) => {
        if (data.length > 0) {
            let customerData = [];
            // eslint-disable-next-line
            data.map(customer => {
                if (customer.IsDeleted === 0) {
                    customerData.push(customer);
                }
            });

            setcustomerData(customerData);
            setFilterCustomer(customerData);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    }

    const showAddress = () => {
        setdisplayAddCustomer("block");
        setIsEdit(0);
    };

    const hideAddress = () => {
        setdisplayAddCustomer("none");
    };

    const FetchCustomers = () => {
        Axiosfetch(baseURL + "GetAllCustomers", "GET", null, CustomerDataSuccess, Failure);
    };

    const EditSelectedCustomer = (customerDetails) => {
        setcustomerEditData(customerDetails);
        setIsEdit(1);
        setdisplayAddCustomer("block");
    };

    const onCustomerSearch = (e) => {
        let searchValue = e.target.value;
        if (searchValue !== "") {
            let customerSearchData = customerData.filter(c => c.Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.EmailID.trim().toLowerCase().includes(searchValue.trim().toLowerCase()));
            setFilterCustomer(customerSearchData);
        }
        else {
            setFilterCustomer(customerData);
        }
    };

    const DeleteSelectedCustomer = (CustomerID) => {
        Axiosfetch(baseURL + "DeleteCustomer", "POST", { ID: CustomerID }, CustomerDeleteSuccess, Failure);
    }

    const CustomerDeleteSuccess = (data) => {
        FetchCustomers();
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
    };

    const SaveImportCustomerDetails = (Importedcustomers) => {
        var AllowedCustomer = localStorage.getItem("apptc") ? localStorage.getItem("apptc") : null;
        if (AllowedCustomer && parseInt(AllowedCustomer) > (customerData.length + Importedcustomers.length)) {
            Axiosfetch(baseURL + "ImportCustomer", "POST", Importedcustomers, CustomerImportSuccess, Failure);
        }
        else {
            Alert.error("Customer Limit Reached. Please contact Administrator", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const CustomerImportSuccess = (data) => {
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });

        hideImportCustomer();
        FetchCustomers();
    };

    const hideImportCustomer = () => {
        setdisplayImportCustomer("none");
    };

    const showImportCustomer = () => {
        setdisplayImportCustomer("block");
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="offset-md-2 col-md-4 col-sm-4">
                        <h5 className="align-right" style={{ fontWeight: "500" }}>Customers</h5>

                    </div>
                    <div className="offset-md-1 col-md-3 col-sm-3" style={{ display: "flex" }}>
                        <input type="text" name="Name" placeholder="Search Customer..."
                            className="form-control" style={{ marginRight: "10px", borderRadius: "20px", paddingLeft: "40px" }}
                            onChange={e => onCustomerSearch(e)}></input>
                        <div className={`${CurrentTheme}Color`} style={{ fontSize: "1rem", position: "absolute", left: "9%", top: "17%" }}>
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-3 align-center">
                        <span style={{ paddingRight: "20px" }} data-tip="Import Customer" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={showImportCustomer}>
                            <FontAwesomeIcon icon={faFileImport} />
                        </span>
                        <span data-tip="Add Customer" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={showAddress}>
                            <FontAwesomeIcon icon={faPlus} />
                        </span>
                    </div>
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <div className="col-md-12 tableQuotationRecordsStyle" style={{ scrollbarColor: "#005582 transparent" }}>
                        <table className="table table-striped">
                            <thead className="StickyHeader">
                                <tr>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Active</th>
                                    <th style={{ width: "250px" }} className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Name</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Address</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Phone</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>EmailID</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>{RegionSymbol.TaxSystem !== undefined ? RegionSymbol.TaxSystem : "GST"}</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    FilterCustomer.length > 0 && FilterCustomer.map(customer => (
                                        <tr key={customer.ID} className="textCenter">
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}><div className={customer.IsDeleted ? "InActiveDiv" : "ActiveDiv"}></div></td>
                                            <td>{customer.Name}</td>
                                            <td className="tdtableCustomersAddressTDStyle">{customer.Address}</td>
                                            <td>{customer.PhoneNumber}</td>
                                            <td>{customer.EmailID}</td>
                                            <td>{customer.CustomerGST}</td>
                                            <td style={{ minWidth: "100px" }}><img className="cursorpointer" title="Edit" src={EditIcon} alt="Edit" onClick={(customerDetails) => EditSelectedCustomer(customer)}></img>
                                                <img className="cursorpointer" title="Delete" onClick={(customerID) => DeleteSelectedCustomer(customer.ID)} style={{ marginLeft: 15 }} src={DeleteIcon} alt="Delete"></img>
                                            </td>
                                        </tr>
                                    ))
                                }
                                {
                                    FilterCustomer.length === 0 && (<tr className="textCenter">
                                        <td colSpan="7">
                                            There are no Customers
                                        </td>
                                    </tr>)
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {displayImportCustomer === "block" && <ImportCustomers SaveImportCustomerDetails={SaveImportCustomerDetails} hideImportCustomer={hideImportCustomer} regionDetails={RegionSymbol}></ImportCustomers>}
                {displayAddCustomer === "block" && <AddCustomer themeColor={CurrentTheme} hideCustomer={hideAddress} getCustomer={FetchCustomers} regionDetails={RegionSymbol} edit={IsEdit} customerdetail={customerEditData} allcustomers={customerData}></AddCustomer>}
            </div>
        </div>
    );
};

export default Customers;